<template>
  <div class="uk-card uk-card-small uk-box-shadow-small uk-card-default uk-margin-bottom">
    <div v-if="pkg.vehicles[0].inCart" class="uk-overlay-default uk-position-cover" style="z-index:10"></div>
    <div class="uk-card-header">
      <h3 class="uk-card-title uk-margin-remove uk-text-truncate uk-width-3-4@m">
        <router-link :to="{ name: 'vehicle-details', params: { id: pkg.id } }" class="uk-link-reset">
          {{ pkg.name }}
        </router-link>
      </h3>
    </div>
    <div class="uk-card-body uk-padding-remove">
      <table class="uk-table uk-table-small uk-table-divider uk-table-middle">
        <thead>
          <tr>
            <th style="width: 25px;">#</th>
            <th class="uk-table-shrink"></th>
            <th class="uk-table-expand">Fahrzeug</th>
            <th class="uk-width-auto uk-text-right uk-preserve-width">Händler-Einkaufspreis Netto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vehicle in pkg.vehicles" :key="vehicle.id">
            <td>
              {{ vehicle.carId }}
            </td>
            <td class="uk-text-nowrap">
              <img
                v-if="vehicle.images.length"
                class="uk-preserve-width"
                :src="vehicle.images[0]['400']"
                :alt="vehicle.name"
                width="40"
                height="40"
              />
              <img
                v-else
                class="uk-preserve-width"
                src="/img/placeholder.png"
                :alt="product.name"
                width="40"
                height="40"
              />
            </td>
            <td>
              <router-link :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }" class="uk-link-text">
                {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.edition }}
              </router-link>
            </td>
            <td class="uk-text-right uk-text-bold">
              {{ vehicle.salepricemerchant | euro }}
            </td>
          </tr>
          <tr>
            <td class="uk-text-right" colspan="4">
              <span class="uk-text-large uk-text-bold"
                ><span class="uk-text-large uk-text-bold">Paketpreis Netto:</span> {{ pkg.priceFormatted }}</span
              >
            </td>
          </tr>
          <tr class="remove-border">
            <td colspan="3" class="uk-text-right" style="padding: 4px 12px;">
              <span class="uk-text-success uk-text-bold"></span>
            </td>
            <td class="uk-text-right" style="padding: 4px 12px;">
              <span class="uk-text-danger uk-text-bold">{{ pkg.discount }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="uk-align-right uk-padding-small">
        <button class="uk-button uk-button-primary" @click.prevent="addToCart">
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: cart"></span>in den Warenkorb
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CartService from '@/services/cart.service'
export default {
  props: {
    pkg: {
      required: true
    }
  },
  data() {
    return {
      modalData: null
    }
  },
  components: {},
  computed: {
    ...mapGetters([
      'mode',
      'customerTypeLabel',
      'modeLabel',
      'modePriceLabel',
      'showEndcustomerPrices',
      'showMerchantPrices',
      'tenant'
    ])
  },
  methods: {
    addToCart() {
      CartService.addPackageToCart(this.pkg.id).then(response => {
        this.$store.dispatch('getCart')
        this.$store.dispatch('getCartCount')
        this.$emit('added', response.data)
      })
    }
  }
}
</script>
<style scoped>
.remove-border {
  border: none !important;
}
</style>
